import React from "react";
import { Link } from "react-router-dom";
import { Reveal } from "@/components/site/Reveal";
export default function ContentBlocks({ blocks = [] }) {
  return (
    <div className="space-y-8">
      {blocks.map((block, index) => (
        <Reveal key={index}>
          {block.type === "heading" ? (
            <h2 className="nm-title pt-6 text-[28px] leading-[1.12] sm:text-[36px]">
              {block.text}
            </h2>
          ) : block.type === "list" ? (
            <ul className="space-y-3">
              {block.items.map((item, i) => (
                <li
                  key={i}
                  className="flex gap-4 rounded-[16px] bg-[#f7f7f7] p-5 text-[17px] leading-[1.45]"
                >
                  <span className="opacity-35">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          ) : block.type === "quote" ? (
            <blockquote className="border-l-2 border-black pl-6 text-[24px] leading-[1.25]">
              {block.text}
            </blockquote>
          ) : block.type === "link" ? (
            block.href.startsWith("/") ? (
              <Link className="nm-link text-[18px]" to={block.href}>
                {block.text}
              </Link>
            ) : (
              <a
                className="nm-link text-[18px]"
                href={block.href}
                rel="noopener noreferrer"
              >
                {block.text}
              </a>
            )
          ) : (
            <p className="whitespace-pre-line text-[18px] leading-[1.6] tracking-[-0.01em] opacity-70">
              {block.text}
            </p>
          )}
        </Reveal>
      ))}
    </div>
  );
}
